export default __webpack_public_path__ + "static/media/heroImage2.b2dd07c0.png";